// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__QMSzA","textDiv":"HeaderCartButton_textDiv__KqC+7","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__ihWRv"};